import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { api, errMsg } from "@/lib/api";

export const TypeChips = ({ types, value, onChange, testid = "rel-type" }) => (
  <div className="flex flex-wrap gap-1.5">
    {types.map((t) => (
      <button key={t.key} type="button" onClick={() => onChange(t.key)} data-testid={`${testid}-${t.key}`}
        className="rounded-full border px-2.5 py-1 text-xs transition-colors"
        style={value === t.key ? { borderColor: t.color, background: `${t.color}26`, color: t.color } : { borderColor: "#2D3442", color: "#A8A090" }}>
        {t.label}
      </button>
    ))}
  </div>
);

export const RoleChips = ({ a, b, names, value, onChange, testid = "rel-role" }) => (
  <div className="flex flex-wrap gap-1.5" data-testid={`${testid}-chips`}>
    {[["a_parent", `${names[a]} is parent of ${names[b]}`], ["b_parent", `${names[b]} is parent of ${names[a]}`], ["siblings", "Siblings"]].map(([k, l]) => (
      <button key={k} type="button" onClick={() => onChange(k)} data-testid={`${testid}-${k}`}
        className={`rounded-full border px-2.5 py-1 text-xs transition-colors ${value === k ? "border-[#10B981] bg-[#10B981]/15 text-[#10B981]" : "border-[#2D3442] text-[#A8A090]"}`}>{l}</button>
    ))}
  </div>
);

export const RelDialog = ({ uid, pair, names, types, initialType, onClose, onSaved }) => {
  const [f, setF] = useState({ type: initialType || "love", status: "", how_they_met: "", notes: "", role: "siblings" });
  const [busy, setBusy] = useState(false);
  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post(`/universes/${uid}/relationships`, { a: pair[0], b: pair[1], ...f, role: f.type === "family" ? f.role : null });
      toast.success(`Created ${data.name}`);
      onSaved(data);
      onClose();
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg" data-testid="rel-create-dialog">
        <form onSubmit={save}>
          <DialogHeader><DialogTitle className="font-display text-3xl">{names[pair[0]]} <span className="text-[#A8A090]">&</span> {names[pair[1]]}</DialogTitle></DialogHeader>
          <div className="space-y-4 py-5">
            <div className="space-y-2"><Label>Relationship</Label><TypeChips types={types} value={f.type} onChange={(type) => setF({ ...f, type })} /></div>
            {f.type === "family" && <div className="space-y-2"><Label>Family role</Label><RoleChips a={pair[0]} b={pair[1]} names={names} value={f.role} onChange={(role) => setF({ ...f, role })} /></div>}
            <div className="space-y-1.5"><Label>Status</Label><Input value={f.status} onChange={(e) => setF({ ...f, status: e.target.value })} placeholder="Courting, married, estranged…" data-testid="rel-status-input" /></div>
            <div className="space-y-1.5"><Label>How they met</Label><Input value={f.how_they_met} onChange={(e) => setF({ ...f, how_they_met: e.target.value })} data-testid="rel-met-input" /></div>
            <div className="space-y-1.5"><Label>Notes</Label><Textarea rows={3} value={f.notes} onChange={(e) => setF({ ...f, notes: e.target.value })} data-testid="rel-notes-input" /></div>
          </div>
          <DialogFooter><Button type="submit" disabled={busy} data-testid="rel-create-save">{busy ? "Linking…" : "Create relationship"}</Button></DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
